import { style } from '@vanilla-extract/css'

const sidebar = style({
  width: '50vw',
  maxWidth: '620px',
  height: '100vh',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '@media': {
    '(max-width: 960px)': {
      display: 'none',
    },
  },
})

const links = style({
  display: 'flex',
  width: '355px',
  flexDirection: 'column',
  gap: '16px',
})

const link = style({
  textDecoration: 'none',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
})

const linkTitle = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '24px',
  fontWeight: '900',
  lineHeight: '1.5',
})

const linkSubtitle = style({
  fontFamily: 'Noto Sans JP Variable, sans-serif',
  fontSize: '13px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const button = style({
  margin: '8px 0',
})

const legalLinks = style({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '8px',
  position: 'absolute',
  bottom: '40px',
  left: '0px',
  right: '0px',
})

const legalLink = style({
  fontSize: '13px',
  lineHeight: '1.5',
  color: '#828282',
  textDecoration: 'underline',
})

export const styles = {
  sidebar,
  links,
  link,
  linkTitle,
  linkSubtitle,
  button,
  legalLinks,
  legalLink,
}
